// @ts-nocheck
import React, { useEffect, useState, ReactNode } from 'react';
import { addExitClickListeners } from "./../ExitOverlay/ExitOverlayLogic";

interface Props {
    children?: ReactNode
    // any props that come into the component
}

function OptanonWrapper() {
  // Adding the 'powered by onetrust' to the exit clicks
  addExitClickListeners();
  
  const oneTrustLoadedEvent = new CustomEvent('onetrustloaded');
  window.dispatchEvent(oneTrustLoadedEvent);
}

const OneTrustWrapper = ({ children }: Props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    script.async = true;
    script.setAttribute("data-document-language", "true");
    script.setAttribute("strategy", "afterInteractive");
    script.setAttribute("data-domain-script", "b0eeb112-ac79-4b9e-a92c-d24837833f34")
    script.type = "text/javascript"
    script.charset="UTF-8"

    script.onload = () => {
      setScriptLoaded(true);
    };

    script.onerror = () => {
      // Handle error if the script fails to load
      console.error("Failed to load script");
    };

    script.addEventListener('load', () => console.log('onetrust loaded', window.dataLayer));

    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      // document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    // Optanon is a callback function once the oneTrust tag is loaded
    // Need to add it to the window object
    window.OptanonWrapper = OptanonWrapper;
  }, [scriptLoaded]);

  return <>{children}</>;
};

export default OneTrustWrapper;
